import React, { useState } from 'react';
import Button from '@dashboard/components/Button';
import CheckoutShareDialog from '@dashboard/components/CheckoutShare/CheckoutShareDialog';

const CheckoutShareButton = ({ checkoutId, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button {...props} onClick={() => setIsOpen(true)} />

      <CheckoutShareDialog
        checkoutId={checkoutId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default CheckoutShareButton;
